"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMediaIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialMediaIcon = function SocialMediaIcon(_ref) {
  var variant = _ref.variant;

  switch (variant) {
    case 'twitter':
      return /*#__PURE__*/_react.default.createElement(_icons.Twitter, null);

    case 'linkedin':
      return /*#__PURE__*/_react.default.createElement(_icons.Linkedin, null);

    case 'youtube':
      return /*#__PURE__*/_react.default.createElement(_icons.Youtube, null);

    case 'facebook':
      return /*#__PURE__*/_react.default.createElement(_icons.Facebook, null);

    case 'instagram':
      return /*#__PURE__*/_react.default.createElement(_icons.Instagram, null);

    default:
      return null;
  }
};

exports.SocialMediaIcon = SocialMediaIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9Tb2NpYWxNZWRpYUljb24udHN4Il0sIm5hbWVzIjpbIlNvY2lhbE1lZGlhSWNvbiIsInZhcmlhbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQUVPLElBQU1BLGVBQStDLEdBQUcsU0FBbERBLGVBQWtELE9BQWlCO0FBQUEsTUFBZEMsT0FBYyxRQUFkQSxPQUFjOztBQUM5RSxVQUFRQSxPQUFSO0FBQ0UsU0FBSyxTQUFMO0FBQ0UsMEJBQU8sNkJBQUMsY0FBRCxPQUFQOztBQUNGLFNBQUssVUFBTDtBQUNFLDBCQUFPLDZCQUFDLGVBQUQsT0FBUDs7QUFDRixTQUFLLFNBQUw7QUFDRSwwQkFBTyw2QkFBQyxjQUFELE9BQVA7O0FBQ0YsU0FBSyxVQUFMO0FBQ0UsMEJBQU8sNkJBQUMsZUFBRCxPQUFQOztBQUNGLFNBQUssV0FBTDtBQUNFLDBCQUFPLDZCQUFDLGdCQUFELE9BQVA7O0FBQ0Y7QUFDRSxhQUFPLElBQVA7QUFaSjtBQWNELENBZk0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBJbnN0YWdyYW0sIFR3aXR0ZXIsIExpbmtlZGluLCBZb3V0dWJlLCBGYWNlYm9vayB9IGZyb20gJy4uL2ljb25zJztcblxuZXhwb3J0IGNvbnN0IFNvY2lhbE1lZGlhSWNvbjogUmVhY3QuRkM8eyB2YXJpYW50Pzogc3RyaW5nIH0+ID0gKHsgdmFyaWFudCB9KSA9PiB7XG4gIHN3aXRjaCAodmFyaWFudCkge1xuICAgIGNhc2UgJ3R3aXR0ZXInOlxuICAgICAgcmV0dXJuIDxUd2l0dGVyIC8+O1xuICAgIGNhc2UgJ2xpbmtlZGluJzpcbiAgICAgIHJldHVybiA8TGlua2VkaW4gLz47XG4gICAgY2FzZSAneW91dHViZSc6XG4gICAgICByZXR1cm4gPFlvdXR1YmUgLz47XG4gICAgY2FzZSAnZmFjZWJvb2snOlxuICAgICAgcmV0dXJuIDxGYWNlYm9vayAvPjtcbiAgICBjYXNlICdpbnN0YWdyYW0nOlxuICAgICAgcmV0dXJuIDxJbnN0YWdyYW0gLz47XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBudWxsO1xuICB9XG59O1xuIl19